import { useEffect, useRef, useState, } from 'react'
import HtmlParser from 'react-html-parser';
import ReCAPTCHA from 'react-google-recaptcha';
import {
    setDateTimeFormatGlobal, settings, settingsPassword, validateEmail, getError, isUndNullEmpNew, getLanguageObj, getResponse, sendMessageCloseCurrentWindow,
    LoadingSection,
} from '../../helpers/UtilsHelper';
import useAuth from '../../auth/useAuth';
import Menu from '../main/Menu';
import { LoginClass } from '../../classes/auth/loginClass.js';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { LoginService } from '../../services/login/LoginService';

const currentMethod = 'RegistrationStatus - function';

export default function RegistrationStatus({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const auth = useAuth();
    const [userLocal, setUserLocal] = useState({});
    const [errors, setErrors] = useState({ email: '', password: '' });
    const [showDetails, setShowDetails] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({ ...LoginClass?.getClass(), firstName: '', lastName: '' });
    const [process, setProcess] = useState({
        showLoading: false,
        check: false,
        back: false,
    });

    const isMount = useRef(true);
    const reCaptchaRef = useRef(ReCAPTCHA);

    const { app, icons, firebase, labels, messages } = settings;
    const { urls } = app?.backend;
    const { fields: dbFields, } = firebase?.firestore;
    const formatDateTime = {
        date: languageObj?.format?.date?.f1,
        time: languageObj?.format?.time?.type,
    };
    //#endregion variables

    //#region methods
    const formDataValidate = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'formDataValidate';
        let response = getResponse({ type: 0 });
        try {
            const errors_ = { email: '', password: '' };
            const requiredMsg = messages?.thisFieldRequired?.[languageObj?.id];

            if (isUndNullEmpNew({ data: formData?.email, subMethod: currentMethod, })?.result) {
                errors_.email = requiredMsg;
                response = getResponse({ type: 1 });
            } else if (!validateEmail(formData.email)) {
                errors_.email = messages?.youMustEnterValidEmail?.[languageObj?.id];
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmpNew({ data: formData?.password, subMethod: currentMethod, })?.result) {
                errors_.password = requiredMsg;
                response = getResponse({ type: 1 });
            } else if (formData.password.length < settingsPassword.maxLength) {
                errors_.password = messages?.youMustEnterValidPassword?.[languageObj?.id];
                response = getResponse({ type: 1 });
            }

            setErrors(errors_);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const checkRegisterStatus = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'checkRegisterStatus';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();
            setShowPassword(false);

            //#region validate
            response = formDataValidate({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion validate

            setProcess(prev => ({ ...prev, showLoading: true, check: true }));

            //#region check register status
            const reCaptchaTokenLocal = await reCaptchaRef?.current?.executeAsync();
            reCaptchaRef?.current?.reset();

            response = await LoginService.getRegisterStatus({
                email: formData?.email,
                password: formData?.password,
                reCaptchaToken: reCaptchaTokenLocal,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const accountMlLocal = response?.result?.accountMl || {};
            //#endregion check register status

            //#region set final data
            setUserLocal(accountMlLocal);
            setFormData(prev => ({
                ...prev,
                firstName: accountMlLocal?.firstName,
                lastName: accountMlLocal?.lastName,
            }));

            setShowDetails(true);
            //#endregion set final data
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, check: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const goToBack = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'goToBack';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();
            setProcess(prev => ({ ...prev, back: true }));
            setShowPassword(false);
            setShowDetails(false);
            setFormData({ ...LoginClass?.getClass(), firstName: '', lastName: '' });
            setErrors({ email: '', password: '' });
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, back: false }));
            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindow({
                    response: response,
                    auth: auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod
                });
            }
        }
    }

    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setFormData({ ...LoginClass?.getClass(), firstName: '', lastName: '' });
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;
            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindow({
                    response: response,
                    auth: auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod
                });
            }
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName={'home'} process={''} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.registerStatus?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.registerStatus?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12'>

                                <div className='login-box-container fade-in'>

                                    <div className={settings?.html?.cards?.default} >
                                        <LoadingSection alt='loadingSection'
                                            className='overlay dark text-white'
                                            height={20}
                                            hidden={!process?.showLoading}
                                            width={20}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        {/*Header*/}
                                        <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt='UserLogin'
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={settings?.images?.userLogin} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.checkRegistrationStatus?.[languageObj?.id]}</h5>
                                                    <div className='mt-1'>
                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                            <i className={`${icons?.fasFa?.search} mr-1`}></i> {labels?.myStatus?.[languageObj?.id]}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <form onSubmit={!showDetails ?
                                            (e) => checkRegisterStatus({ e: e, subMethod: 'form - onSubmit' }) :
                                            (e) => goToBack({ e: e, subMethod: 'form - onSubmit' })}
                                            method='post'>

                                            {/*Body*/}
                                            <div className='card-body px-4 pt-2'>
                                                {showDetails ?
                                                    <div className='form-group position-relative mb-4'>
                                                        <label className='small font-weight-bold text-uppercase form-label-uppercase'>{labels?.user?.[languageObj?.id]}</label>
                                                        <div className='position-relative'>
                                                            <i className={`${icons?.fasFa?.userPrefix} position-absolute input-icon-left`} />
                                                            <input className='form-control border-0 shadow-sm form-input-icon'
                                                                placeholder={labels?.displayName?.[languageObj?.id]}
                                                                readOnly={showDetails}
                                                                title={labels?.displayName?.[languageObj?.id]}
                                                                value={`${formData?.firstName || ''} ${formData?.lastName || ''}`} />
                                                        </div>
                                                    </div>
                                                    : <></>}
                                                <div className='form-group position-relative mb-4'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase'>{labels?.email?.[languageObj?.id]}</label>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.envelope} position-absolute input-icon-left`} />
                                                        <input className='form-control border-0 shadow-sm form-input-icon'
                                                            onChange={(e) => setFormData(prev => ({ ...prev, [dbFields?.email]: e.target.value }))}
                                                            onFocus={() => setErrors(prev => ({ ...prev, email: '' }))}
                                                            placeholder={labels?.email?.[languageObj?.id]}
                                                            readOnly={showDetails} autoFocus
                                                            title={labels?.email?.[languageObj?.id]}
                                                            autoComplete='email'
                                                            value={formData?.email || ''} />
                                                    </div>
                                                    <div className='form-error-text mt-1'>{HtmlParser(errors?.email)}</div>
                                                </div>

                                                {!showDetails ? (
                                                    <div className='form-group position-relative mb-4'>
                                                        <label className='small font-weight-bold text-uppercase form-label-uppercase'>{labels?.password?.[languageObj?.id]}</label>
                                                        <div className='position-relative'>
                                                            <i className={`${icons?.fasFa?.lock} position-absolute input-icon-left`} />
                                                            <input className='form-control border-0 shadow-sm form-input-icon-both'
                                                                onChange={(e) => setFormData(prev => ({ ...prev, [dbFields?.password]: e.target.value }))}
                                                                onFocus={() => setErrors(prev => ({ ...prev, password: '' }))}
                                                                placeholder='••••••••'
                                                                readOnly={showDetails}
                                                                title={labels?.password?.[languageObj?.id]}
                                                                type={showPassword ? 'text' : 'password'}
                                                                autoComplete='current-password'
                                                                value={formData?.password || ''} />
                                                            <span className='position-absolute input-icon-right'
                                                                onClick={() => setShowPassword(!showPassword)}>
                                                                <i className={showPassword ? icons?.fasFa?.eye : icons?.fasFa?.eyeSlash} />
                                                            </span>
                                                        </div>
                                                        <div className='form-error-text mt-1'>{HtmlParser(errors?.password)}</div>
                                                    </div>
                                                ) : (
                                                    <></>
                                                )}

                                                <div className='d-flex justify-content-end align-items-right mb-0'>
                                                    <a href='/forgotPassword' className='link-primary-bold'>{labels?.forgotYourPassword?.[languageObj?.id]}</a>
                                                </div>
                                            </div>

                                            {/*Footer limpio*/}
                                            <div className='card-footer border-0 bg-white px-4 pb-4'>
                                                <div className='form-group mb-3'>
                                                    <button data-title={!showDetails ? labels?.send?.[languageObj?.id] : labels?.back?.[languageObj?.id]}
                                                        type='submit'
                                                        disabled={process?.showLoading}
                                                        className='btn btn-primary btn-block shadow-sm font-weight-bold btn-primary py-2'>
                                                        {!process?.check && !process?.back ? (
                                                            <i className={!showDetails ? icons?.fasFa?.checkCircle : icons?.fasFa?.arrowAltCircleLeft} />
                                                        ) : (
                                                            <span className={`${settings?.react?.html?.spinner?.borderSm}`} aria-hidden='true'></span>
                                                        )} {!showDetails ? labels?.send?.[languageObj?.id] : labels?.back?.[languageObj?.id]}
                                                    </button>
                                                    <button data-title={labels?.home?.[languageObj?.id]}
                                                        type='button'
                                                        onClick={(e) => window.location.href = urls?.home}
                                                        className='btn btn-light btn-block border shadow-sm font-weight-bold px-4 text-secondary btn-general'>
                                                        <i className={icons?.fasFa?.home} /> {labels?.home?.[languageObj?.id]}
                                                    </button>
                                                </div>
                                            </div>

                                        </form>


                                    </div>
                                </div>

                                <div className='text-muted text-center text-small mt-4'>
                                    <p className='recaptcha-notice'>
                                        {labels?.protectedByReCAPTCHA?.[languageObj?.id]} - <a target='_blank'
                                            href={settings?.app?.reCAPTCHA?.urlPrivaciConditions}
                                            className='link-primary'
                                            rel='noreferrer'>{labels?.privacyAndConditions?.[languageObj?.id]}
                                        </a>
                                    </p>
                                </div>


                                {showDetails ? (
                                    <div className='card login-card shadow-lg border-0 mt-4 fade-in slide-up'>
                                        <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                            <h5 className='mb-0 font-weight-bold text-dark'>{labels?.registrationJourney?.[languageObj?.id]}</h5>
                                        </div>
                                        <div className='card-body px-4 pb-4'>
                                            <div className='timeline timeline-premium'>

                                                <div className='time-label'>
                                                    <span className='bg-green'>{setDateTimeFormatGlobal({ date: userLocal?.created, type: formatDateTime?.date, format: 0, addTime: false, withSeconds: false, subMethod: currentMethod })?.result}</span>
                                                </div>
                                                <div>
                                                    <i className={`${icons?.fasFa?.userCheck} bg-green`} />
                                                    <div className='timeline-item shadow'>
                                                        <span className='time'>
                                                            <i className={icons?.fasFa?.clock} /> {setDateTimeFormatGlobal({ date: userLocal?.created, type: '', format: formatDateTime?.time, addTime: false, withSeconds: true, subMethod: currentMethod })?.result}
                                                        </span>
                                                        <h5 className='timeline-header'>
                                                            <label className='text-primary'>{labels?.registrationDone}.</label> {labels?.theUserHasAlreadyMadeRegistration?.[languageObj?.id]}.
                                                        </h5>
                                                    </div>
                                                </div>

                                                <div className='time-label'>
                                                    <span className={userLocal?.emailVerified ? 'bg-green' : 'bg-yellow'}>
                                                        {userLocal?.emailVerified ? setDateTimeFormatGlobal({ date: userLocal?.emailVerifiedDate, type: formatDateTime?.date, format: 0, addTime: false, withSeconds: false, subMethod: currentMethod })?.result : `${labels?.pending?.[languageObj?.id]}...`}
                                                    </span>
                                                </div>
                                                <div>
                                                    <i className={userLocal?.emailVerified ? `${icons?.fasFa?.envelope} bg-green` : `${icons?.fasFa?.envelope} bg-yellow`} />
                                                    <div className='timeline-item shadow'>
                                                        <span className='time'>
                                                            <i className={icons?.fasFa?.clock} /> {userLocal?.emailVerified ? setDateTimeFormatGlobal({ date: userLocal?.emailVerifiedDate, type: '', format: formatDateTime?.time, addTime: false, withSeconds: true, subMethod: currentMethod })?.result : '00:00'}
                                                        </span>
                                                        <h5 className='timeline-header no-border'>
                                                            <label className='text-primary'> {userLocal?.emailVerified ? labels?.confirmationDone?.[languageObj?.id] : labels?.waitingConfirmation?.[languageObj?.id]}.</label> {userLocal?.emailVerified ? `${labels?.theUserHasAlReadyConfirmedEmail?.[languageObj?.id]}.` : `${messages?.youMustConfirmYourEmailAccountCompleteRegistration?.[languageObj?.id]}`}
                                                        </h5>
                                                    </div>
                                                </div>

                                                <div className='time-label'>
                                                    <span className={userLocal?.accountApproved ? 'bg-green' : userLocal?.emailVerified ? 'bg-yellow' : 'bg-gray'}>
                                                        {userLocal?.accountApproved ? setDateTimeFormatGlobal({ date: userLocal?.accountApprovedDate, type: formatDateTime?.date, format: 0, addTime: false, withSeconds: false, subMethod: currentMethod })?.result : `${labels?.pending?.[languageObj?.id]}...`}
                                                    </span>
                                                </div>
                                                <div>
                                                    <i className={userLocal?.accountApproved ? `${icons?.fasFa?.userShield} bg-green` : userLocal?.emailVerified ? `${icons?.fasFa?.userShield} bg-yellow` : `${icons?.fasFa?.userShield} bg-gray`} />
                                                    <div className='timeline-item shadow'>
                                                        <span className='time'>
                                                            <i className={icons?.fasFa?.clock} /> {userLocal?.accountApproved ? setDateTimeFormatGlobal({ date: userLocal?.accountApprovedDate, type: '', format: formatDateTime?.time, addTime: false, withSeconds: true, subMethod: currentMethod })?.result : '00:00'}
                                                        </span>
                                                        <h5 className='timeline-header no-border'>
                                                            <label className='text-primary'> {userLocal?.accountApproved ? labels?.approvalDone?.[languageObj?.id] : labels?.waitingApproval?.[languageObj?.id]}.</label> {userLocal?.accountApproved ? `${labels?.theSystemAdministratorApprovedAccount?.[languageObj?.id]}.` : `${labels?.systemAdministratorMustApproveAccount?.[languageObj?.id]}.`}
                                                        </h5>
                                                    </div>
                                                </div>

                                                <div className='time-label'>
                                                    <span className={userLocal?.roleId ? 'bg-green' : userLocal?.accountApproved ? 'bg-yellow' : 'bg-gray'}>
                                                        {userLocal?.roleId ? setDateTimeFormatGlobal({ date: userLocal?.roleDate, type: formatDateTime?.date, format: 0, addTime: false, withSeconds: false, subMethod: currentMethod })?.result : `${labels?.pending?.[languageObj?.id]}...`}
                                                    </span>
                                                </div>
                                                <div>
                                                    <i className={userLocal?.roleId ? `${icons?.fasFa?.userTag} bg-green` : userLocal?.accountApproved ? `${icons?.fasFa?.userTag} bg-yellow` : `${icons?.fasFa?.userTag} bg-gray`} />
                                                    <div className='timeline-item shadow'>
                                                        <span className='time'>
                                                            <i className={icons?.fasFa?.clock} /> {userLocal?.roleId ? setDateTimeFormatGlobal({ date: userLocal?.roleDate, type: '', format: formatDateTime?.time, addTime: false, withSeconds: true, subMethod: currentMethod })?.result : '00:00'}
                                                        </span>
                                                        <h5 className='timeline-header no-border'>
                                                            <label className='text-primary'> {userLocal?.roleId ? labels?.roleAssignmentDone?.[languageObj?.id] : labels?.waitingAssignRole?.[languageObj?.id]}.</label> {userLocal?.roleId ? `${labels?.systemAdministratorAssignedRole?.[languageObj?.id]}.` : `${labels?.systemAdministratorMustAssignYouRole?.[languageObj?.id]}.`}
                                                        </h5>
                                                    </div>
                                                </div>

                                                <div className='time-label'>
                                                    <span className={(userLocal?.roleId && userLocal?.emailVerified && userLocal?.accountApproved) ? 'bg-green' : 'bg-gray'}>
                                                        {(userLocal?.roleId && userLocal?.emailVerified && userLocal?.accountApproved) ? setDateTimeFormatGlobal({ date: userLocal?.roleDate, type: formatDateTime?.date, format: 0, addTime: false, withSeconds: false, subMethod: currentMethod })?.result : `${labels?.pending?.[languageObj?.id]}...`}
                                                    </span>
                                                </div>
                                                <div>
                                                    <i className={(userLocal?.roleId && userLocal?.emailVerified && userLocal?.accountApproved) ? `${icons?.fasFa?.checkCircle} bg-green` : `${icons?.fasFa?.checkCircle} bg-gray`} />
                                                    <div className='timeline-item shadow'>
                                                        <span className='time'>
                                                            <i className={icons?.fasFa?.clock} /> {(userLocal?.roleId && userLocal?.emailVerified && userLocal?.accountApproved) ? setDateTimeFormatGlobal({ date: userLocal?.roleDate, type: '', format: formatDateTime?.time, addTime: false, withSeconds: true, subMethod: currentMethod })?.result : '00:00'}
                                                        </span>
                                                        <h5 className='timeline-header no-border'>
                                                            <label className='text-primary'> {(userLocal?.roleId && userLocal?.emailVerified && userLocal?.accountApproved) ? labels?.processesCompletedSuccessfully?.[languageObj?.id] : labels?.waitingPreviousProcesses?.[languageObj?.id]}.</label> {(userLocal?.roleId && userLocal?.emailVerified && userLocal?.accountApproved) ? `${labels?.youCanNowLogIntoOurSystemWithCredentials?.[languageObj?.id]}.` : `${labels?.youMustFinishAboveProcessesAccessSystem?.[languageObj?.id]}.`}
                                                        </h5>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>

                            {/* <div> */}
                            {/* <div style={{ display: 'g-recaptcha' }}> */}
                            <ReCAPTCHA className='g-recaptcha'
                                ref={reCaptchaRef}
                                sitekey={settings?.app?.reCAPTCHA?.reCaptchaSiteKey}
                                hl={languageObj?.id}
                                size='invisible' />
                            {/* </div> */}
                        </div>
                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}
            </div>
        </div>

    )
}